module.exports = __webpack_public_path__ + "static/assets/4c900aaf51a39ada875fd0f484b2c3b1.svg";